import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import { Config, sanitizeOrganizationId } from "@core/configuration";
var lastSeenOrganization = "lastSeenOrganization";
var lastUsedRegion = "lastUsedRegion";
export var OrganizationLocalStorage = /*#__PURE__*/ function() {
    "use strict";
    function OrganizationLocalStorage() {
        _class_call_check(this, OrganizationLocalStorage);
    }
    OrganizationLocalStorage.getOrganizationFromLocalStorage = function getOrganizationFromLocalStorage() {
        var isInLastUsedRegion = localStorage.getItem(lastUsedRegion) === Config.CloudPlatform.region;
        if (typeof Storage === "undefined" || !isInLastUsedRegion) {
            return "";
        }
        var ref;
        return (ref = sanitizeOrganizationId(localStorage.getItem(lastSeenOrganization))) !== null && ref !== void 0 ? ref : "";
    };
    OrganizationLocalStorage.setOrganizationInLocalStorage = function setOrganizationInLocalStorage(organizationId) {
        var region = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Config.CloudPlatform.region;
        if (organizationId) {
            localStorage.setItem(lastSeenOrganization, organizationId);
            localStorage.setItem(lastUsedRegion, region);
        }
    };
    OrganizationLocalStorage.clearOrganizationInLocalStorage = function clearOrganizationInLocalStorage() {
        localStorage.removeItem(lastSeenOrganization);
    };
    return OrganizationLocalStorage;
}();

//# sourceMappingURL=OrganizationLocalStorage.js.map